import { render, staticRenderFns } from "./info_generalencuesta.vue?vue&type=template&id=386818e2"
import script from "./info_generalencuesta.vue?vue&type=script&lang=js"
export * from "./info_generalencuesta.vue?vue&type=script&lang=js"
import style0 from "./info_generalencuesta.vue?vue&type=style&index=0&id=386818e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports